import { CodeBrowser } from "components/icons/generated";
import Badge from "ds/components/Badge";
import Box from "ds/components/Box";
import CardContent from "ds/components/Card/components/Content";
import CardHeader from "ds/components/Card/components/Header";
import CardWrapper from "ds/components/Card/components/Wrapper";
import IconEmphasized from "ds/components/IconEmphasized";
import Link from "ds/components/Link";
import Typography from "ds/components/Typography";
import { Template } from "types/generated";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";
import TagsList from "components/TagsList";
import { pluralize } from "shared/Pluralize";

import { getTemplateMarketplaceTemplateUrl, isTemplateNew } from "../utils";
import TemplateCardDeployButton from "./DeployButton";

type TemplateCardProps = {
  template: Template;
};

const TemplateCard = ({ template }: TemplateCardProps) => {
  const templateUrl = getTemplateMarketplaceTemplateUrl(template.id);

  return (
    <CardWrapper variant="primary">
      <CardHeader
        prefix={<IconEmphasized icon={CodeBrowser} />}
        suffix={
          <TemplateCardDeployButton
            templateId={template.id}
            latestVersionId={template.latestVersion!.id}
          />
        }
      >
        {` `}
      </CardHeader>

      <CardContent hasHeader gap="large">
        <Box gap="large" align="center">
          <Link href={templateUrl} variant="secondary" size="inherit" noEllipsis>
            <Typography tag="span" variant="p-t7">
              {template.name}
            </Typography>
          </Link>
          <Badge
            variant="gray"
            type="weak"
            text={`${template.deploymentsCount} ${pluralize("Deployment", template.deploymentsCount)}`}
          />
          {template.deploymentsCount === 0 && isTemplateNew(template.createdAt) && (
            <Badge variant="blue" type="strong" text="NEW" />
          )}
        </Box>

        {template.description && (
          <Box direction="row" align="start">
            <ListEntitiesItemDescriptionMultipleLines
              lines={1}
              hasChevronLink
              description={template.description}
            />
          </Box>
        )}

        {template.labels.length > 0 && (
          <TagsList
            tags={template.labels}
            alwaysExpanded
            withEmptyPlaceholder
            withTopMargin={false}
          />
        )}
      </CardContent>
    </CardWrapper>
  );
};

export default TemplateCard;
